import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OneExamCycle from '../ones/OneExamCycle';
import { MdCheck, MdSearch, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import SubjectRegistrationForm from "../ones/SubjectRegistrationForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await appContext.getMyExamCycles()
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.myExamCycles) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							My Exam Cycles
						</h6>
					</div>

					<div className="col-12 col-md-12">
						
						<div className="d-flex justify-content-between mb-4">
						
							<MdSearch
								className="align-self-center text-muted"
								size={24}
								style={{
									flexShrink: 0,
								}}
							/>

							<input
								className="form-control mNoMargin align-self-center"
								style={{
									flexGrow: 1,
								}}
								onChange={(e) => setSearchFilter(e.target.value)}
								placeholder="Filter by title"
							/>

						</div>
						<hr/>

						{
							(appContext.myExamCycles && appContext.myExamCycles.length > 0) ?
								appContext.myExamCycles.map((item, i) => {
									if (searchFilter) {
										if (
											String(item.title).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
										) {
											return (
												<OneExamCycle data={item} key={i} />
											)
										} else {
											return "";
										}
									} else {
										return (
											<OneExamCycle data={item} key={i} />
										)
									}
								})
								:
								<h6
									className=""
									style={{
										fontSize: "14px",
									}}
								>
									No exam cycle was found
								</h6>
						}
						
					</div>

					

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}